import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { withStyles, Paper } from '@material-ui/core';
import moment from "moment";
import { hasPermission, parseURL, BackButton } from '../../../../sc-utilities';
import * as actions from '../../store/billingAccountActions';
import LoadingDialog from '../LoadingDialog'
import SoftwareLicenseForm from './SoftwareLicenseForm'
import History from '../../../../../History';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        minHeight: '500px',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    }
});

const SoftwareLicenseCreate = props => {
    const { permissions, classes, creating, onCreateSoftwareLicense, activeCustomer, translations, listLicensePrototypes } = props;
    const [createData, setCreateData] = useState({ licensePrototypes: [], loadingData: true })


    useEffect(() => {
        const fetchData = async () => {
            let data = await listLicensePrototypes({ ActiveCustomerID: activeCustomer })
            setCreateData({ licensePrototypes: data, loadingData: false })
        }
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let { AccountID } = parseURL(window.location.search)


    const submitHandler = async (data) => {
        data['ActiveAccountID'] = AccountID;
        await onCreateSoftwareLicense({ ...data, ActiveCustomerID: activeCustomer });
        History.goBack();
    };

    let statuses = [{ value: 'active', displayValue: translations["active"] || 'Active' }, { value: 'inactive', displayValue: translations["inactive"] || 'Inactive' }]

    let initialValues = {
        Name: '',
        SecretKey: '',
        Status: 'active',
        ExpiresAt: moment().add(1, 'year'),
        LicensePrototypeID: createData.licensePrototypes && createData.licensePrototypes[0] ? createData.licensePrototypes[0].value : null,
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required('Required'),
            SecretKey: Yup.string().required('Required'),
            Status: Yup.string().required('Required'),
            ExpiresAt: Yup.date()
                .notRequired()
                .nullable(true),
            LicensePrototypeID: Yup.string().required('Required')

        },
        FormTitle: translations["software_license_create"] || `Create software license`,
        ButtonSubmit: hasPermission(permissions, 'software_license_create') ? {
            Title: translations["create"] || "Create",
            Color: 'primary'
        } : null,
    };
    return createData.loadingData ? <LoadingDialog /> :
        <Paper className={classes.root}>
            {BackButton(translations, classes.customTooltip)}
            <SoftwareLicenseForm
                initialValues={initialValues}
                translations={translations}
                formSettings={formSettings}
                handleSubmit={submitHandler}
                statuses={statuses}
                licensePrototypes={createData.licensePrototypes}
                loading={creating}
            ></SoftwareLicenseForm>
        </Paper>

};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
        creating: state.billing.accounts.softwareLicenses.creating
    };
};

const mapDispatchToProps = dispatch => {
    return {
        listLicensePrototypes: id => dispatch(actions.listLicensePrototypes(id)),
        onCreateSoftwareLicense: params => dispatch(actions.onSoftwareLicenseCreate(params)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SoftwareLicenseCreate));